import { API_URL } from '../config';
// API URL is imported from config.js

// Pagination defaults
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;

// Table sorting directions
export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
